/**
 * useAppTranslation — thin wrapper around react-i18next's useTranslation.
 *
 * All components import from this hook rather than directly from react-i18next,
 * so a future library swap or wrapper change is transparent to feature code.
 *
 * Requirements: 8.3
 */
import { useTranslation, UseTranslationResponse } from "react-i18next";

export function useAppTranslation(
  namespace: string | string[],
): UseTranslationResponse<string, undefined> {
  return useTranslation(namespace);
}
